import { useMutation, useQuery } from 'react-query';
import { fetchGuestCvPrefill, submitGuestCv } from './api';

/** Finalize (terminal) the guest CV — consumes the grant server-side. */
export const useSubmitGuestCv = (sessionToken: string | undefined) =>
  useMutation(() => submitGuestCv(sessionToken as string));

/**
 * Best-effort personal-detail suggestions (from Supply) for a brand-new guest CV. `enabled`
 * is gated by the caller (session present AND no existing CV); the fetch never throws, so the
 * query never error-states — a miss/failure resolves to `null`. Cached per grant link token
 * for the lifetime of the page load.
 *
 * `scopeKey` is the immutable link token, deliberately NOT the session token: the session
 * token rotates on every mid-edit recovery, and a rotating key would drop this cache and
 * un-settle `isFetched` while the guest is typing (see GuestCvDataProvider).
 */
export const useGuestCvPrefill = (
  sessionToken: string | undefined,
  enabled: boolean,
  scopeKey: string | null
) =>
  useQuery(
    ['guest-cv-prefill', scopeKey],
    () => fetchGuestCvPrefill(sessionToken as string),
    {
      enabled: enabled && Boolean(sessionToken),
      retry: false,
      staleTime: Infinity,
      cacheTime: Infinity
    }
  );
